import React from 'react';
import { useSelector } from 'react-redux';
import { func, string, node } from 'prop-types';
import useStyles from 'hooks/useStyles';

import BaseModal from 'components/BaseModal';
import { HK } from 'constants/locales';
import Button from 'components/Button';
import { LiveLogo, ClassLogo } from 'components/Icon';

import { getAppRegion } from 'reduxModules/app/selector';

import styles from './PromotionModal.scss';

function PromotionModal({
  onClose,
  notice,
  description,
  title,
  hint,
  ctaText,
  onCtaClick,
}) {
  useStyles(styles);
  const region = useSelector(getAppRegion);
  const ctaButton = (
    <div className={styles.ctaButton}>
      <Button block text={ctaText} onClick={onCtaClick} />
      <span className={styles.hint}> {hint} </span>
    </div>
  );
  const Logo =
    region === HK ? (
      <LiveLogo className={styles.logo} />
    ) : (
      <ClassLogo className={styles.logo} />
    );

  return (
    <BaseModal
      onClose={onClose}
      closable
      buttons={ctaButton}
      classNameMap={{ root: styles.root }}
    >
      {Logo}
      <h2 className={styles.title}>{title}</h2>
      <p
        className={styles.description}
        dangerouslySetInnerHTML={{ __html: description }}
      />
      <span
        className={styles.notice}
        dangerouslySetInnerHTML={{ __html: notice }}
      />
    </BaseModal>
  );
}

PromotionModal.propTypes = {
  onClose: func.isRequired,
  title: string.isRequired,
  ctaText: string.isRequired,
  onCtaClick: func.isRequired,
  notice: string,
  hint: node,
  description: string,
};

PromotionModal.defaultProps = {
  notice: '',
  hint: undefined,
  description: '',
};

export default PromotionModal;
